

$(function () {
    $(".setup-wiz").each(function (idx, element) {

        var pubApps = [];
        var selectedAppIds = [];
        var configuringApp = null;
        var configuringApps = [];
        var checkInstanceXhr;
        var subscriptionActivation = {
            applications: []
        };

        var _onFetchAppsSuccess = function (data, dataType) {
            if (dataType == "html") {
                $(element).find(".step-apps .bounce-spinner").hide();
                $(element).find(".apps-container").html(data).show();
                $(element).find(".step-apps .btn").removeProp("disabled");
            }
            else if (dataType == "json") {
                pubApps = data;
            }
        };

        /**
         * Displays the apps screen
         */
        var _showApps = function () {
            selectedAppIds = [];
            configuringApp = null;
            checkInstanceXhr = null;
            subscriptionActivation.applications = [];

            //remove content and replace it with a spinner
            $(".step-apps .apps-container").html('<div class="bounce-spinner">' +
                '<div class="bounce1"></div>' +
                '<div class="bounce2"></div>' +
                '<div class="bounce3"></div>' +
                '</div>');

            _fetchApps();
            _fetchApps("json");

            $(".step-welcome, .step-app-setup, .step-finish, .step-error, .step-done").hide();
            $(".step-apps").show();
        };

        /**
         * Retrieves a list of all current apps with pricing for
         * the current pricing list
         */
        var _fetchApps = function (dataType) {

            dataType = dataType || "html";

            $.ajax({
                url: "/apps/publicapps/" + (dataType == "json" ? "?responseType=json" : ""),
                method: "GET",
                dataType: dataType,
                success: function (d) {
                    _onFetchAppsSuccess(d, dataType)
                },
                error: function (x, s, e) {
                    //TODO: display error
                }
            })
        };

        /**
         * Displays an error. Because there might be more than one alert on the page you can
         * specified an optional css parent selector to display the error for one 
         * specific alert component
         */
        var _showError = function (error, parentSelector) {
            if (!parentSelector) parentSelector = '';
            else parentSelector = parentSelector + ' ';

            $(parentSelector + ".alert div").text(error);
            $(parentSelector + ".alert").show();
        };

        /**
         * Adds an application to the Trial subscription change
         */
        var addAppToSubscription = function (id, sitename) {
            var app = {};
            app.appId = id;

            if (sitename) app.siteName = sitename;

            subscriptionActivation.applications.push(app);
        };

        /**
         * Shows the error screen and hides all other screens/steps
         * Not to be confused with _showError which is a helper function to display an
         * alert in the current screen
         */
        var _showErrorScreen = function (error) {
            $(".step-error p").text(error
                + ". Please click 'Retry' to try again or click 'Go Back' to change your subscription's settings");

            $(".step-welcome, .step-apps, .step-app-setup, .step-finish, .step-done").hide();
            $(".step-error").show();
        }

        /**
         * Shows the "done" screen
         */
        var _showDone = function () {
            $(".step-welcome, .step-apps, .step-error, .step-finish, .step-app-setup").hide();
            $(".step-done").show();
        }

        /**
         * Triggers an ajax request to activate the Trial subscription
         */
        var _activate = function () {
            $.ajax({
                url: "/subscriptions/activatejson/",
                method: "POST",
                data: subscriptionActivation,
                dataType: "json",
                success: function (d) {
                    if (d.Success == false) {
                        _showErrorScreen(d.Error);
                    }
                    else if (d.Success == true) {
                        _showDone();
                    }
                },
                error: function (x, s, e) {
                    _showErrorScreen(e);
                }
            });
        };

        /**
         * Shows the finish screen
         */
        var _showFinish = function () {
            $(".step-welcome, .step-apps, .step-app-setup, .step-error, .step-done").hide();
            $(".step-finish").show();

            _activate();
        }

        /**
         * Displays the configuration form for the selected application
         */
        var _showSetup = function () {
            if (configuringApps.length == 0) {
                _showFinish();
                return;
            }

            var app = configuringApps.shift();
            configuringApp = app;

            if (!app.IsInstanceBased) {
                addAppToSubscription(app.Id);
                _showSetup();
                return;
            }

            //$(".step-app-setup .app-su-header-icon img").attr("src", "/content/images/logos/" + app.SmallIcon);
            $(".step-app-setup .sc-status").removeClass("sc-status-loading")
                .removeClass("sc-status-ok")
                .removeClass("sc-status-oops");

            $(".step-app-setup button.btn").prop("disabled", "disabled");
            $(".step-app-setup .input-group input").val([]);
            $(".step-app-setup .app-name").text(app.Name);
            $(".step-app-setup .app-desc").text(app.ShortDescription);

            $(".step-welcome, .step-apps, .step-error, .step-finish, .step-done").hide();
            $(".step-app-setup").show();
        };

        /**
         * checks whether a website is already in use or not
         */
        var _checkInstance = function (instance) {
            var $status = $(".step-app-setup .site-checker .sc-status");
            var $btn = $(".step-app-setup .btn");

            if (instance.length == 0) {
                $status.removeClass("sc-status-loading")
                    .removeClass("sc-status-oops")
                    .removeClass("sc-status-ok")
                    .children("span.status-text").text("");

                $btn.prop("disabled", "disabled");
            }
            else {

                $btn.prop("disabled", "disabled");

                $status.removeClass("sc-status-oops")
                    .removeClass("sc-status-ok")
                    .addClass("sc-status-loading")
                    .children("span.status-text").text("Checking this sitename...");

                if (checkInstanceXhr && checkInstanceXhr.readyState < 4)
                    checkInstanceXhr.abort();

                checkInstanceXhr = $.ajax({
                                        //#StemsAccountsDev:
                                        //TODO: pass in the hard-coded app Id
                                        url: "/appinstances/json/5/?instance=" + encodeURIComponent(instance),
                                        method: "GET",
                                        dataType: "json",
                                        success: function (d) {
                                            if (d == true) {
                                                $btn.prop("disabled", "disabled");

                                                $status.addClass("sc-status-oops")
                                                    .removeClass("sc-status-loading")
                                                    .removeClass("sc-status-ok")
                                                    .children("span.status-text").text("This sitename is not available");
                                            }
                                            else {
                                                $btn.removeProp("disabled");

                                                $status.addClass("sc-status-ok")
                                                    .removeClass("sc-status-loading")
                                                    .removeClass("sc-status-oops")
                                                    .children("span.status-text").text("This sitename is available");
                                            }
                                        },
                                        error: function (x, s, e) {
                                            if (e == "abort") return;


                                            $btn.prop("disabled", "disabled");
                                            $status.addClass("sc-status-oops")
                                                .removeClass("sc-status-loading")
                                                .removeClass("sc-status-ok")
                                                .children("span.status-text").text("An error occurred");
                                            }
                                    });

            }
        }

        //by default, bootstrap completely removes alerts from DOM a when closed
        //this component requires a different behavior to simply show/hide the alert
        $("body").off("click", ".widget-modal.setup-wiz .alert .close")
            .on("click", ".widget-modal.setup-wiz .alert .close", function () {
                $(this).parents(".alert").hide();
            });

        $(".step-welcome .btn").click(function () {
            _showApps();
        })

        //clicking continue on the "Select Applications" step
        $(".step-apps .btn").click(function () {

            //get list of selected application IDs
            selectedAppIds = $(".step-apps .app-list .widget-switch.on input")
                .map(function (idx, element) {
                    return $(this).val();
                })
                .get();

            //edge-case guard to make sure at least one app has been selected
            //before proceeding to next step
            if (!selectedAppIds || selectedAppIds.length === 0) {
                _showError("Please select an application before proceeding", ".step-apps");
                return;
            }

            var app = pubApps.filter(function (item) { return item.Id == selectedAppIds[0] });

            if (app.length === 0) {
                _showError("Error: could not find the selected applications", ".step-apps");
                return;
            }

            configuringApps = $.grep(pubApps, function (app, idx) {
                for (var i = 0; i < selectedAppIds.length; i++) {
                    if (selectedAppIds[i] == app.Id) {
                        return true;
                    }
                }
                return false;
            });

            _showSetup();
        })

        //on application selected/unselected
        $("body").off(WidgetEvents.STEMS_ON_CHANGE, ".step-apps .widget-switch")
            .on(WidgetEvents.STEMS_ON_CHANGE, ".step-apps .widget-switch", function () {
                var checked = $(this).val();

                if (checked) {
                    $(this).parents(".app-list li").addClass("selected");
                }
                else {
                    $(this).parents(".app-list li").removeClass("selected");
                }
            });

        //listens for input changes on the sitename's textbox
        $(".step-app-setup .input-group input").keyup(function () {
            var site = $(this).val();
            var trimmedSite = site.trim();

            _checkInstance(trimmedSite);
        });

        //clicking "Continue" on the application setup screen
        $(".step-app-setup .btn").click(function () {
            if (!configuringApp) return;

            var sitename = $(".step-app-setup .input-group input").val().trim();
            addAppToSubscription(configuringApp.Id, sitename);

            _showSetup();
        });

        //handles clicking the "Go Back" button on the error screen
        $(".step-error .btn-default").click(function () {
            _showApps();
        });

        //handles clicking the "Retry" button on the error screen
        $(".step-error .btn-primary").click(function () {
            _showFinish();
        });

        //closes the wizard when "Close" button is clicked on the "Done" screen
        $(".step-done .btn").click(function () {
            window.location.reload();
        });
    })
})